import { createStore } from 'vuex'
import VuexORM, { HasManyBy } from '@vuex-orm/core'
import VuexORMSearch from '@vuex-orm/plugin-search'

import * as api from '@/api'
import database from '@/store/database'
import bus from '@/plugins/eventbus'
import modules from '@/store/modules'

// Vuex-ORM 0.36's HasManyBy.getRelatedRecords iterates the store's relations
// Map (insertion order) and pushes any whose id matches `keys` — losing the
// foreign-key array order. That makes `item.tags` render in store-insertion
// order rather than `item.tagIds` order. The codebase has exactly one
// hasManyBy definition (CollectionItem.tags), so patching the prototype here
// is safe and restores per-item tag ordering across all surfaces.
if (HasManyBy?.prototype?.getRelatedRecords) {
  HasManyBy.prototype.getRelatedRecords = function (relations, keys) {
    const records = []
    keys.forEach(key => {
      const record = relations.get(key)
      if (record) records.push(record)
    })
    return records
  }
}

VuexORM.use(VuexORMSearch)

const store = createStore({
  modules,
  plugins: [VuexORM.install(database)],
  strict: import.meta.env.NODE_ENV !== 'production',
  devtools: import.meta.env.DEV || import.meta.env.MODE === 'staging',
  actions: {
    resetApp({ dispatch, commit }) {
      // Delete entire vuex data
      dispatch('entities/deleteAll')

      commit('collectionItems/reset')
      commit('collections/resetState')
    },
  },
})

// Add API and event bus to store for convenience
store.$api = api
store.$bus = bus

// Export setup function for Vue 3
export const setupStore = app => {
  app.use(store)

  // Make store instance available on app config for plugins
  app.config.globalProperties.$store = store
}

export default store
